import { createFileRoute } from '@tanstack/react-router'

import AdminPage from '@/components/pages/backoffice/_user/_admin/containers/AdminPage'

export const Route = createFileRoute('/_backoffice/user/admin/')({
  component: AdminPage
})
